var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Button',{staticClass:"p-button-danger",attrs:{"icon":"pi pi-trash","label":_vm.$t('common.buttons.resetFilters')},on:{"click":function($event){return _vm.resetFilters(_vm.filtersApplied, _vm.fieldsToExcludeFromFilters)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }